import { useCallback } from 'react';
import { useBeforeUnload as _useBeforeUnload } from 'react-router-dom';

export const useBeforeUnload = (doBlock: boolean) => {
	_useBeforeUnload(
		useCallback(
			(e) => {
				if (doBlock) {
					e.preventDefault();
					return (e.returnValue = '');
				}
			},
			[doBlock]
		)
	);
};

export default useBeforeUnload;
